import AdminPage from '@cohort/merchants/components/AdminPage';
import SectionSeparator from '@cohort/merchants/components/SectionSeparator';
import LinkSection from '@cohort/merchants/pages/settings/integrations/LinkSection';
import UserInformationSection from '@cohort/merchants/pages/users/user/overview/UserInformationSection';
import UserPropertiesSection from '@cohort/merchants/pages/users/user/overview/UserPropertiesSection';
import {useTranslation} from 'react-i18next';

const UserOverviewPage = (): JSX.Element => {
  const {t} = useTranslation('pages', {keyPrefix: 'users.user.overview.page'});

  const headerConfig = {
    title: t('title'),
    subtitle: t('subtitle'),
  };

  return (
    <AdminPage header={headerConfig} className="space-y-10">
      <SectionSeparator />
      <LinkSection
        title={t('sectionInformationTitle')}
        description={t('sectionInformationSubtitle')}
      />
      <UserInformationSection />
      <SectionSeparator />
      <LinkSection
        title={t('sectionPropertiesTitle')}
        description={t('sectionPropertiesSubtitle')}
      />
      <UserPropertiesSection />
    </AdminPage>
  );
};

export default UserOverviewPage;
